import React, { createContext, useContext, useState, useMemo, useCallback } from "react";
import { translations } from "../i18n/translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "en";
    const saved = window.localStorage.getItem("deppcm_lang");
    if (saved === "en" || saved === "es") return saved;
    const browser = (window.navigator.language || "en").toLowerCase();
    return browser.startsWith("es") ? "es" : "en";
  });

  const toggleLang = useCallback(() => {
    setLang((l) => {
      const next = l === "en" ? "es" : "en";
      if (typeof window !== "undefined") {
        window.localStorage.setItem("deppcm_lang", next);
      }
      return next;
    });
  }, []);

  const t = useMemo(() => translations[lang], [lang]);

  const value = useMemo(() => ({ lang, t, toggleLang }), [lang, t, toggleLang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
